import * as React from "react";

function SvgIcons8Rename(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M17 4v2c1.465 0 2.563.29 3.25.625.344.168.605.355.719.469.023.023.023.015.031.031v17.75c-.008.016-.008.008-.031.031-.114.114-.375.301-.719.469-.688.336-1.785.625-3.25.625v2c1.734 0 3.113-.352 4.125-.844.34-.164.617-.367.875-.562.258.195.535.398.875.562 1.012.492 2.39.844 4.125.844v-2c-1.465 0-2.563-.29-3.25-.625-.344-.168-.605-.355-.719-.469-.023-.023-.023-.015-.031-.031V7.125c.008-.016.008-.008.031-.031.114-.114.375-.301.719-.469C24.438 6.289 25.535 6 27 6V4c-1.734 0-3.113.352-4.125.844-.34.164-.617.367-.875.562a5.112 5.112 0 00-.875-.562C20.113 4.352 18.735 4 17 4zM1 10v12h18v-2H3v-8h16v-2zm24 0v2h4v8h-4v2h6V10zM5 14v4h8v-4z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Rename);
